import { format, parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { SttTable } from '../../../sporttia/all';
import { getDateLocale } from '../../../lib/dateLocale';

export default function ClassesList({ classes, onFetch }: any) {
    const { t } = useTranslation();

    return (
        <SttTable
            autoload={false}
            onFetch={onFetch}
            data={classes}
            columns={[
                {
                    title: t('labels.date'),
                    value: (row: any) =>
                        format(parseISO(row.ini), 'd MMM yyyy', {
                            locale: getDateLocale(),
                        }),
                },
                {
                    title: t('labels.time'),
                    type: 'periodTime',
                    value: (row: any) => ({ ini: row.ini, end: row.end }),
                },
                {
                    title: t('facility.facility'),
                    type: 'text',
                    value: (row: any) =>
                        row.facility ? row.facility.name : '',
                },
                {
                    title: t('activity.teacher'),
                    type: 'text',
                    value: (row: any) => (row.teacher ? row.teacher.name : ''),
                },
            ]}
        />
    );
}
